/**
 * @generated SignedSource<<9034127388838c2f86a4a579b6ca0218>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type WebFormSubmissionsOrderByField = "completed_at" | "created_at" | "duration" | "score" | "user_name" | "%future added value";
export type WebFormSubmissionsOrderByInput = {
  direction: OrderDirection;
  field: WebFormSubmissionsOrderByField;
};
export type QuizSubmissionsTablePaginationQuery$variables = {
  after?: string | null;
  before?: string | null;
  completedAfter?: string | null;
  contentUsageId?: string | null;
  first?: number | null;
  id: string;
  isComplete?: boolean | null;
  isFailed?: boolean | null;
  isPassed?: boolean | null;
  last?: number | null;
  membersOnly?: boolean | null;
  orderBy?: WebFormSubmissionsOrderByInput | null;
  percentageGreaterThanOrEqual?: number | null;
  percentageLessThan?: number | null;
  search?: string | null;
};
export type QuizSubmissionsTablePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionsTable_PaginationFragment">;
  } | null;
};
export type QuizSubmissionsTablePaginationQuery = {
  response: QuizSubmissionsTablePaginationQuery$data;
  variables: QuizSubmissionsTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedAfter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentUsageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isComplete"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFailed"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPassed"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membersOnly"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "percentageGreaterThanOrEqual"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "percentageLessThan"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v16 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "completedAfter",
    "variableName": "completedAfter"
  },
  {
    "kind": "Variable",
    "name": "contentUsageId",
    "variableName": "contentUsageId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "isComplete",
    "variableName": "isComplete"
  },
  {
    "kind": "Variable",
    "name": "isFailed",
    "variableName": "isFailed"
  },
  {
    "kind": "Variable",
    "name": "isPassed",
    "variableName": "isPassed"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "membersOnly",
    "variableName": "membersOnly"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "percentageGreaterThanOrEqual",
    "variableName": "percentageGreaterThanOrEqual"
  },
  {
    "kind": "Variable",
    "name": "percentageLessThan",
    "variableName": "percentageLessThan"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QuizSubmissionsTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "QuizSubmissionsTable_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "QuizSubmissionsTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "WebFormSubmissionNodeConnection",
                "kind": "LinkedField",
                "name": "submissions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WebFormSubmissionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebFormSubmission",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "durationSeconds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPassed",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormSubmissionResult",
                            "kind": "LinkedField",
                            "name": "result",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "score",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "total",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "correctAnswers",
                                "plural": true,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "incorrectAnswers",
                                "plural": true,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatar",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTest",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [
                  "orderBy",
                  "search",
                  "isComplete",
                  "completedAfter",
                  "percentageGreaterThanOrEqual",
                  "percentageLessThan",
                  "isPassed",
                  "isFailed",
                  "membersOnly"
                ],
                "handle": "connection",
                "key": "QuizSubmissionsTable_submissions",
                "kind": "LinkedHandle",
                "name": "submissions"
              }
            ],
            "type": "WebFormRevision",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b2ea747ca6ee9e7a1f37becdd8dbee7",
    "id": null,
    "metadata": {},
    "name": "QuizSubmissionsTablePaginationQuery",
    "operationKind": "query",
    "text": "query QuizSubmissionsTablePaginationQuery(\n  $after: String\n  $before: String\n  $completedAfter: DateTime\n  $contentUsageId: ID\n  $first: Int\n  $isComplete: Boolean\n  $isFailed: Boolean\n  $isPassed: Boolean\n  $last: Int\n  $membersOnly: Boolean\n  $orderBy: WebFormSubmissionsOrderByInput\n  $percentageGreaterThanOrEqual: Float\n  $percentageLessThan: Float\n  $search: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...QuizSubmissionsTable_PaginationFragment_41TTY3\n    id\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment QuizSubmissionsTableRow_submission on WebFormSubmission {\n  id\n  completedAt\n  durationSeconds\n  hasPassed\n  result {\n    score\n    total\n    percentage\n    correctAnswers {\n      id\n    }\n    incorrectAnswers {\n      id\n    }\n  }\n  user {\n    id\n    fullName\n    ...ProfileAvatarFragment\n  }\n}\n\nfragment QuizSubmissionsTable_PaginationFragment_41TTY3 on WebFormRevision {\n  id\n  submissions(contentUsageId: $contentUsageId, orderBy: $orderBy, search: $search, isComplete: $isComplete, completedAfter: $completedAfter, percentageGreaterThanOrEqual: $percentageGreaterThanOrEqual, percentageLessThan: $percentageLessThan, isPassed: $isPassed, isFailed: $isFailed, membersOnly: $membersOnly, first: $first, after: $after, last: $last, before: $before) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...QuizSubmissionsTableRow_submission\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7daea8c0254ac1581ecaccd28ec15866";

export default node;
